<div class="esn-toolbar">
  <ng-content select="[esn-toolbar-search]" />
  <ng-content />
  <ng-content select="[esn-toolbar-end]" />
</div>
